import { Link } from "react-router-dom";

export function ReflectionCard() {
  return (
    <div className="bg-brand-primary rounded-2xl p-6 text-white">
      {/* Sparkle icon */}
      <div className="flex justify-center mb-4">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <path d="M16 4L18 12L26 14L18 16L16 24L14 16L6 14L14 12L16 4Z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
          <path d="M24 4L25 7L28 8L25 9L24 12L23 9L20 8L23 7L24 4Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
        </svg>
      </div>

      <p className="text-center text-sm text-text-on-brand-secondary mb-2">Reflection</p>
      <h2 className="text-center text-xl font-semibold mb-2">Start a reflection</h2>
      <p className="text-center text-sm text-text-on-brand-secondary mb-6">
        A short exercise to understand your relationship patterns.
      </p>

      <Link
        to="/guided-chat/new?type=reflection"
        className="block w-full bg-white text-brand-primary text-center py-4 rounded-full font-medium hover:bg-gray-100 transition-colors"
      >
        Begin
      </Link>
    </div>
  );
}
